module.exports = __webpack_public_path__ + "static/media/room-9.fd9b03e2.jpeg";